export default (theme) => ({
    displayTitle: {
        boxSizing: 'border-box',
        display: 'flex',
        flexWrap: 'wrap',
        WebkitBoxPack: 'justify',
        justifyContent: 'space-between',
        fontSize: '18px',
        fontWeight: 500,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    displayBody: {
        paddingTop: '20px',
    },
});